import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@els/els-react--dropdown';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { sortingOptionsTypeMap } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogConstants';

const generateRenderSortingOptions = ({ onByValue, sortingType, onOccurrence, onClickClearSelected }) => {
  const sortingOptionsHandlersMap = {
    [occurrence]: onOccurrence,
    [byValue]: onByValue,
  };

  // eslint-disable-next-line react/prop-types, react/function-component-definition
  return ({ closeFlyout }) => {
    return (
      <RadioButtonGroup
        options={[
          { label: sortingOptionsTypeMap[occurrence], value: occurrence },
          { label: sortingOptionsTypeMap[byValue], value: byValue },
        ]}
        value={sortingType}
        onChange={(e) => {
          const { value } = e.target;
          const handler = sortingOptionsHandlersMap[value];
          if (!handler) return;
          handler();
          onClickClearSelected();
          closeFlyout();
        }}
        shouldBeSelectedByDefault={false}
        a11y={{ name: 'Sort filters' }}
      />
    );
  };
};

function SortingDropdown({ sortingType, onOccurrence, onByValue, onClickClearSelected }) {
  const options = [
    {
      render: generateRenderSortingOptions({ sortingType, onOccurrence, onByValue, onClickClearSelected }),
    },
  ];

  return (
    <Dropdown
      label={`Sort by ${sortingOptionsTypeMap[sortingType]}`}
      options={options}
      showSelectedAsLabel={false}
      id="new-author-checkboxes-dialog-sorting-dropdown"
      className="new-author-checkboxes-dialog__sorting-dropdown"
      flyoutProps={{
        placement: 'bottom-end',
        pointer: true,
        pointerType: 'primary',
      }}
    />
  );
}

SortingDropdown.propTypes = {
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  onOccurrence: PropTypes.func.isRequired,
  onByValue: PropTypes.func.isRequired,
  onClickClearSelected: PropTypes.func.isRequired,
};

export default SortingDropdown;
